import React from 'react';

import theInformationLogo from '../../../assets/images/the-information-logo.svg';

import { useCurrentUser } from '../../hooks';
import { new_session_path, subscribe_one_path } from '../../routes';
import styles from './styles.module.css';

export default function Header() {
  const { currentUser } = useCurrentUser();
  const firstName = currentUser ? currentUser.name?.split(' ')[0] || currentUser.username : '';
  return (
    <div className={styles.header}>
      <div className="container container-padded">
        <div className={styles.headerContent}>
          <a href="/">
            <img src={theInformationLogo} alt="The Information" className={styles.headerLogo} />
          </a>
          {/* TODO: Add mobile menu */}
          <div className={styles.user}>
            {currentUser ? (
              <a href="/">Welcome, {firstName} </a>
            ) : (
              <>
                <a href={new_session_path()} className={styles.signInLink}>
                  Sign In
                </a>
                <a href={subscribe_one_path()} className={styles.subscribeLink}>
                  Subscribe
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
